export default __webpack_public_path__ + "static/media/collov-home.bf9bfe7d.jpg";